import { MembershipStatusHistoryItem } from "@gymflow/types";
import { QueryKey, queryOptions } from "@tanstack/react-query";

import { api } from "../../api";

const keys = {
  all: () => ["staffApiSubscription"] as QueryKey,
  perUser: (userId: unknown) => [...keys.all(), userId] as QueryKey,
  getMembershipStatusHistory: (userId: unknown) =>
    [...keys.perUser(userId), "getMembershipStatusHistory"] as QueryKey,
};

export const staffApiSubscription = {
  keys,
  queries: {
    getMembershipStatusHistory: (userId: string | undefined) =>
      queryOptions({
        queryKey: keys.getMembershipStatusHistory(userId),
        queryFn: async () => {
          return (
            await api.get<MembershipStatusHistoryItem[]>(
              `/user/member/${userId}/membership-history`,
            )
          ).data;
        },
      }),
  },
  infiniteQueries: {},
  mutations: {},
};
